// extracted by mini-css-extract-plugin
module.exports = {"campusTable":"CampusList_campusTable__2x-QG","loaderWrapper":"CampusList_loaderWrapper__3Qt0F"};